import React, { Component } from 'react'
import { connect } from 'react-redux';
import { message, Layout } from 'antd';
import TopNav from '../../components/topnav/topnav';
import ResetpasswordForm from '../../components/resetpassword/resetpasswordform';
import Footer from '../../components/footer/footer';
import { bindActionCreators } from 'redux';
import {resetPassword} from "../../../../core/actions/auth"
const { Content } = Layout;

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleAction: false
    };
  }
  componentWillReceiveProps(nextProps) {
    const {resetPasswordError,resetPasswordSuccess} = nextProps
    if(resetPasswordSuccess) {
      message.success(resetPasswordSuccess)
    }
    if(resetPasswordError) message.error(resetPasswordError)
  }

  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  render() {
    const { toggleAction } = this.state
    return (
      <div className="">
        <TopNav history={this.props.history} toggleAction={toggleAction} toggleModal={this.toggleModal}/>
        <Content className="reset-password">
          <ResetpasswordForm 
          resetPasswordError={this.props.resetPasswordError}
          resetPasswordSuccess={this.props.resetPasswordSuccess}
          loading={this.props.loading}
          resetPassword={this.props.resetPassword}
          match={this.props.match}
          toggleModal={this.toggleModal}/>
        </Content>
        <Footer />
      </div>
    )
  } 
}

const mapStateToProps = (state)=>({
  resetPasswordSuccess:state.auth.resetPasswordSuccess,
  resetPasswordError: state.auth.resetPasswordError,
  loading:state.auth.loading
})
const mapDispatchToProps = (dispatch)=>bindActionCreators({
resetPassword
},dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(ResetPassword)